$(() => {
  $('select.select2:not(.mosaic-customize-select2, .searchable-select-input)').select2({ language: 'it' })
})
